<template>
  <div id="endgame_containier" class="border-padding">
  <main>
    <div v-if="$parent.league == 'nba' || $parent.league == 'wnba'">
        <h4>You don't need a 3 (Actually you probably do)</h4>
        <p>This is a calculator to show the 2pt% for which shooting a 2 is better than shooting a 3 at a given percentage in end of game situations</p>
        <p>Example: To see the 2pt% that is equivalent to a 30% 3pt shot with 15 seconds left when down 3, enter 15 for seconds remaining, -3 for margin and 30 for 3pt%</p>
        Seconds Remaining: <input v-model="seconds_remaining" placeholder="" maxlength="2" size="2">
        Margin: <input v-model="margin" placeholder="" maxlength="2" size="2">
        3pt%: <input v-model="three_pt_pct" placeholder="" maxlength="2" size="2">
        <div class="border-padding">
            <button v-on:click="getStats()">Get 2pt% Needed</button>
        </div>
        <p v-if="two_pt_pct">If you can make the 2pt shot more than <b>{{two_pt_pct}}%</b> of the time it is better than the 3</p>
        <details>
            <summary>Methodology Details</summary>
            <p>Results should be treated as a rough estimate, not a definitive answer. The overall lesson from the results should be that teams aren't aggressive enough at seeking out 3s when trailing.</p>
            <p>Based on win probability model trained on games from 2012-2020.</p>
            <p>Assumes both teams are evenly matched. Being a big favourite/underdog could shift things a bit in one direction</p>
            <p>Offensive rebounds and drawing shooting fouls are ignored to simplify the calculation.
                Based on the frequency at which and-1s occur, I think they are negligible enough to ignore.
                Including shooting fouls drawn would probably shift things very slightly towards taking a 2. Not including them just makes the calculation easier.
                I also think the difference in OReb% on 2s vs 3s is close enough to ignore them when thinking 2 vs 3.
            </p>
        </details>
    </div>
    <div v-else>
        <p>Not Available for league: {{ $parent.league }}</p>
    </div>
    <p style="color:red;" v-if="show_error_message">Error Getting Results</p>
  </main>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Endgame',
  data () {
    return {
      show_error_message: false,
      seconds_remaining: undefined,
      margin: undefined,
      three_pt_pct: undefined,
      two_pt_pct: undefined
    }
  },
  watch: {
    '$parent.league': 'changeLeague'
  },
  methods: {
    changeLeague () {
      this.$router.push({name: 'endgame', params: {league: this.$parent.league}})
    },
    getStats () {
      this.show_error_message = false
      var baseUrl = process.env.API_BASE_URL
      var url = baseUrl + 'get-endgame-breakeven-2-pct/' + this.$parent.league + '/' + this.margin + '/' + this.seconds_remaining + '/' + this.three_pt_pct
      axios.get(url, {})
        .then((response) => {
          this.two_pt_pct = response.data.breakeven2_pct
        }, (error) => {
          this.show_error_message = true
          this.error = error
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Endgame.vue